import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FilterCenterFocusIcon(props: IconProps) {
    return <Icon {...props} iconKey={"filter_center_focus"}/>
}
